import React from 'react';
import PropTypes from 'prop-types';

const Question = ({ faq }) => {
	let listItems = [];

	for (let x = 0; x < faq.length; x++) {
		listItems[x] = `{
			"@type": "Question",
			"name": "${faq[x].question.replace(/"/g, "'")}",
			"acceptedAnswer": {
				"@type": "Answer",
				"text": "${faq[x].answer.replace(/<[^>]+>/g, '').replace(/"/g, "'")}"
			}
		}`;
	}

	return (
		<script
			type='application/ld+json'
			dangerouslySetInnerHTML={{
				__html: `{
				"@context": "https://schema.org",
				"@type": "FAQPage",
				"mainEntity": [
					${[...listItems]}
				]
			}`,
			}}
		/>
	);
};

Question.propTypes = {
	faq: PropTypes.array,
};

export default Question;
